import { render, staticRenderFns } from "./OrganizationTabGeneral.vue?vue&type=template&id=8ea4facc"
import script from "./OrganizationTabGeneral.vue?vue&type=script&lang=js"
export * from "./OrganizationTabGeneral.vue?vue&type=script&lang=js"
import style0 from "./OrganizationTabGeneral.vue?vue&type=style&index=0&id=8ea4facc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports